import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import CalendarView from "../../components/CalendarView";
import { useSiteContext } from "../../contexts/SiteProvider";
import BarChart from "./BarChart";
import DashboardCards from "./DashboardCards";
import UsersPieChart from "./UsersPieChart";
import { DASHBOARD_URL } from "../../api/AdminUrls";
import { get } from "../../services/smartApiService";

const DashBoardAdmin: React.FC = () => {
  const { setTitle } = useSiteContext();
        const [cardData, setCardData] = useState<any[]>([]);
  useEffect(() => {
    setTitle("Dashboard ");
  }, []);




  const loadTableData = () => {
    let URL = DASHBOARD_URL.GET_COMPLETED_TRAINEE_PROJECT;
    const subscription = get(URL).subscribe((response) => {
      setCardData(response.data );
       console.log("Chart Response",response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
  }, []);

// const tagData = [
//   { label: "SCR", value: 100, color: "gradient-purple" },
//   { label: "ENG", value: 250, color: "gradient-blue" },
//   { label: "MKT", value: 320, color: "gradient-green" },
//   { label: "HR", value: 150, color: "gradient-orange" },
// ];

const colors = [
  "gradient-purple",
  "gradient-blue",
  "gradient-green",
  "gradient-orange",
  "gradient-pink",
];

const tagData = cardData.map((item, index) => ({
  label: item.project_name,
  value: item.completed_count,
  color: colors[index % colors.length],
}));

  return (
    <div className="columns is-multiline">
      <motion.div
        className="column is-9"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="smart-sds-box m-0">
          <DashboardCards />
        </div>
      </motion.div>
      <div className="column is-3">
        <div className="smart-sds-box">
          <UsersPieChart url={""} title="% Scores Achieved" />
        </div>
      </div>
      <div className="column is-12">
         <p className="has-text-centered  has-text-weight-semibold is-size-4">Project wise Sessions completed</p>
  <div className="columns is-multiline dashboard-tags-grid p-0">
      {tagData.map((tag, idx) => (
        <div key={idx} className="column is-6-mobile is-4-tablet is-2-desktop custom-is-2-5 ">
          <motion.div
            className={`p-0 dashboard-tag-card ${tag.color}`}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: idx * 0.1, duration: 0.5, type: "spring" }}
          >
            <div className="card-content has-text-centered">
              <span className="tag is-light is-medium is-rounded">
                {tag.label}
              </span>
              <span className="tag is-white is-medium is-rounded ml-3">
                {tag.value}
              </span>
            </div>
          </motion.div>
        </div>
      ))}
    </div>
      </div>
      <div className="column is-9 ">
        <div className="smart-sds-box">
          <CalendarView />
        </div>
      </div>
      <div className="column is-3">
        <div className="smart-sds-box">
          {/* <UsersBarChart /> */}
          <BarChart />
        </div>
      </div>
      {/* <div className="column is-12">
        <Ratings />
      </div> */}
    </div>
  );
};

export default DashBoardAdmin;
